if(!customElements.get('aura5-product-carousel')){
 customElements.define('aura5-product-carousel',class extends HTMLElement{
  connectedCallback(){
   this.track=this.querySelector('.aura5-carousel__track');
   this.previous=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
   if(!this.track)return;
   this.refresh=()=>{
    const cards=[...this.track.querySelectorAll(':scope > .product-item')];
    const max=this.track.scrollWidth-this.track.clientWidth;
    this.previous.disabled=this.track.scrollLeft<=2;
    this.next.disabled=this.track.scrollLeft>=max-2;
    const first=cards.findIndex(card=>card.offsetLeft+card.offsetWidth>this.track.scrollLeft+2);
    const visible=cards.filter(card=>card.offsetLeft>=this.track.scrollLeft-2&&card.offsetLeft+card.offsetWidth<=this.track.scrollLeft+this.track.clientWidth+2).length;
    this.querySelector('[data-position]').textContent=cards.length?`${Math.max(first+1,1)}–${Math.min(Math.max(first+1,1)+Math.max(visible,1)-1,cards.length)} / ${cards.length}`:'';
    this.querySelector('.aura5-carousel__controls').hidden=max<=2;
   };
   this.move=direction=>this.track.scrollBy({left:direction*(this.track.clientWidth+parseFloat(getComputedStyle(this.track).columnGap||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   this.onPrevious=()=>this.move(-1);this.onNext=()=>this.move(1);
   this.onKey=event=>{if(event.target===this.track&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);}};
   this.previous.addEventListener('click',this.onPrevious);this.next.addEventListener('click',this.onNext);
   this.track.addEventListener('scroll',this.refresh,{passive:true});this.track.addEventListener('keydown',this.onKey);
   this.observer=new ResizeObserver(this.refresh);this.observer.observe(this.track);this.refresh();
  }
  disconnectedCallback(){this.observer?.disconnect();this.previous?.removeEventListener('click',this.onPrevious);this.next?.removeEventListener('click',this.onNext);this.track?.removeEventListener('scroll',this.refresh);this.track?.removeEventListener('keydown',this.onKey);}
 });
}
